<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <h3 class="panel-title">
        Top Products by Revenue
        <CalculationTooltip text="Top products ranked by total revenue in the selected date range." />
      </h3>
    </div>
    <div class="panel-body">
      <BarChart v-if="chartData" :key="chartKey" :data="chartData" :options="chartOptions" />
      <p v-else class="text-muted">No product data available.</p>
    </div>
  </div>
</template>

<script>
import { Bar as BarChart } from 'vue-chartjs';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import CalculationTooltip from '../../scheduling-dashboard/components/CalculationTooltip.vue';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default {
  name: 'TopProductsChart',
  components: { BarChart, CalculationTooltip },
  props: {
    productPerformance: { type: Object, required: true }
  },
  data: function() {
    return {
      chartKey: 0
    };
  },
  watch: {
    productPerformance: function() {
      this.chartKey++;
    }
  },
  computed: {
    chartData() {
      if (!this.productPerformance || !this.productPerformance.by_revenue || this.productPerformance.by_revenue.length === 0) {
        return null;
      }
      var products = this.productPerformance.by_revenue;
      return {
        labels: products.map(function(d) { return d.product_name; }),
        datasets: [{
          label: 'Revenue',
          data: products.map(function(d) { return d.total_revenue / 100; }),
          backgroundColor: '#5cb85c'
        }]
      };
    },
    chartOptions() {
      return {
        indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: function(context) {
                return '$' + context.parsed.x.toLocaleString();
              }
            }
          }
        },
        scales: {
          x: {
            beginAtZero: true,
            ticks: {
              callback: function(value) {
                return '$' + value.toLocaleString();
              }
            }
          }
        }
      };
    }
  }
};
</script>
